'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    GlowEffect: ()=>GlowEffect
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const react_namespaceObject = require("motion/react");
const index_cjs_namespaceObject = require("../../../utils/index.cjs");
function GlowEffect({ className, colors = [
    '#FF5733',
    '#33FF57',
    '#3357FF',
    '#F1C40F'
], mode = 'rotate', blur = 'medium', transition, scale = 1, duration = 5 }) {
    const BASE_TRANSITION = {
        repeat: 1 / 0,
        duration: duration,
        ease: 'linear'
    };
    const animations = {
        rotate: {
            background: [
                `conic-gradient(from 0deg at 50% 50%, ${colors.join(', ')})`,
                `conic-gradient(from 360deg at 50% 50%, ${colors.join(', ')})`
            ],
            transition: {
                ...transition ?? BASE_TRANSITION
            }
        },
        pulse: {
            background: colors.map((color)=>`radial-gradient(circle at 50% 50%, ${color} 0%, transparent 100%)`),
            scale: [
                +scale,
                1.1 * scale,
                +scale
            ],
            opacity: [
                0.5,
                0.8,
                0.5
            ],
            transition: {
                ...transition ?? {
                    ...BASE_TRANSITION,
                    repeatType: 'mirror'
                }
            }
        },
        breathe: {
            background: [
                ...colors.map((color)=>`radial-gradient(circle at 50% 50%, ${color} 0%, transparent 100%)`)
            ],
            scale: [
                +scale,
                1.05 * scale,
                +scale
            ],
            transition: {
                ...transition ?? {
                    ...BASE_TRANSITION,
                    repeatType: 'mirror'
                }
            }
        },
        colorShift: {
            background: colors.map((color, index)=>{
                const nextColor = colors[(index + 1) % colors.length];
                return `conic-gradient(from 0deg at 50% 50%, ${color} 0%, ${nextColor} 50%, ${color} 100%)`;
            }),
            transition: {
                ...transition ?? {
                    ...BASE_TRANSITION,
                    repeatType: 'mirror'
                }
            }
        },
        flowHorizontal: {
            background: colors.map((color)=>{
                const nextColor = colors[(colors.indexOf(color) + 1) % colors.length];
                return `linear-gradient(to right, ${color}, ${nextColor})`;
            }),
            transition: {
                ...transition ?? {
                    ...BASE_TRANSITION,
                    repeatType: 'mirror'
                }
            }
        },
        static: {
            background: `linear-gradient(to right, ${colors.join(', ')})`
        }
    };
    const getBlurClass = (blur)=>{
        if ('number' == typeof blur) return `blur-[${blur}px]`;
        const presets = {
            softest: 'blur-xs',
            soft: 'blur-sm',
            medium: 'blur-md',
            strong: 'blur-lg',
            stronger: 'blur-xl',
            strongest: 'blur-xl',
            none: 'blur-none'
        };
        return presets[blur];
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(react_namespaceObject.motion.div, {
        style: {
            '--scale': scale,
            willChange: 'transform',
            backfaceVisibility: 'hidden'
        },
        animate: animations[mode],
        className: (0, index_cjs_namespaceObject.cn)('pointer-events-none absolute inset-0 h-full w-full', 'scale-[var(--scale)] transform-gpu', getBlurClass(blur), className)
    });
}
exports.GlowEffect = __webpack_exports__.GlowEffect;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "GlowEffect"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
